/**
 * Files API
 */
import { apiClient } from "./client";
import { useMutation } from "@tanstack/react-query";

export interface FileUploadResponse {
    filePath: string;
    fileUrl: string;
    fileName: string;
    contentType: string;
    size: number;
}

/**
 * Uploads a file
 */
export const uploadFile = async (file: File): Promise<FileUploadResponse> => {
    const formData = new FormData();
    formData.append("file", file);

    // Don't set Content-Type manually - axios will set it automatically with the correct boundary
    const response = await apiClient.post<FileUploadResponse>("/files/upload", formData);

    return response.data;
};

/**
 * React Query hook for uploading a file
 */
export const useUploadFile = () => {
    return useMutation({
        mutationFn: uploadFile,
    });
};